import { render, staticRenderFns } from "./UserBaseInfo.vue?vue&type=template&id=5fa1fecf"
import script from "./UserBaseInfo.vue?vue&type=script&lang=js"
export * from "./UserBaseInfo.vue?vue&type=script&lang=js"
import style0 from "./UserBaseInfo.vue?vue&type=style&index=0&id=5fa1fecf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports